import React, { createContext, useContext, useState } from "react";
import { LIANG_HUANG_SESSIONS } from "../../../../config/liangHuang2026";

export const WizardContext = createContext();

// All sessions are pre-selected by default; guests opt out of the ones they cannot attend.
const defaultSessionSelections = Object.fromEntries(
  LIANG_HUANG_SESSIONS.map((session) => [session.field, true])
);

export const WizardProvider = ({ children }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [chinesename, setChinesename] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [sessionSelections, setSessionSelections] = useState(defaultSessionSelections);

  const setSessionSelected = (field, selected) => {
    setSessionSelections((current) => ({ ...current, [field]: selected }));
  };

  return (
    <WizardContext.Provider
      value={{
        firstname, setFirstname,
        lastname, setLastname,
        chinesename, setChinesename,
        email, setEmail,
        phone, setPhone,
        sessionSelections, setSessionSelected,
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

export const useWizard = () => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error("useWizard must be used within a WizardProvider");
  }
  return context;
};
